import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-review-feedback",
  "use": "foquz-icon-review-feedback-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-review-feedback\"><path d=\"M15 1H3c-1.103 0-2 .913-2 2.037V11c0 1.123.897 2.037 2 2.037h4v3.395c0 .312.35.493.597.309l3.903-3.704H15c1.103 0 2-.914 2-2.037V3.037C17 1.913 16.103 1 15 1z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol